<template>
	<div id="app">
		<!-- 头部 -->
		<header>
			<div class="header_l">
				<img :src="logoImg" alt="" class="logo">
				<div class="header_l_item">
					<div class="title">中国智慧工程研究会职业教育专业委员会</div>
					<div class="english">Professional Committee of Vocational Education•China Wisdom Engineering Association</div>
				</div>
			</div>
			<div class="header_r">
			  <el-input placeholder="请输入内容" v-model="search_value" class="input-with-select" @change="search_result">
			    <el-button slot="append" icon="el-icon-search" @click="search_result"></el-button>
			  </el-input>
			</div>
		</header>
		<!-- 头部 -->
		
		
		<!-- 导航栏 -->
		<el-menu :default-active="activeIndex2" class="el-menu-demo" mode="horizontal" @select="handleSelect"
			background-color="rgb(0,95,175)" text-color="#fff" active-text-color="#ffd04b" router >
			<template v-for="item in navs">
				<!-- 一级导航 -->
				<template v-if="item.children.length == 0">
					<el-menu-item :index="item.url">{{item.name}}</el-menu-item>
				</template>
				
				<!-- 二级导航 -->
				<template v-else-if="item.children.length != 0">
					<el-submenu :index="item.url">
						<template slot="title">{{item.name}}</template>
						<template v-for="item2 in item.children">
							<el-menu-item :index="item2.url">{{item2.name}}</el-menu-item>
						</template>
					</el-submenu>
				</template>
			</template>
		</el-menu>
		<!-- 导航栏 -->

		<!-- 轮播图 -->
		<el-carousel height="360px" :interval="banners_interval" v-if="banner_show == 'whole'">
			<el-carousel-item v-for="item in banners" :key="item.id">
				<div class="banner_img" :style="{'background-color':item.background_color,}">
					<!-- <el-image style="cursor: pointer;" :src="item.image" :title="item.name" @click="links(item.url,item.jump_type)" fit="scale-down"></el-image> -->
					<img :src="item.image" :title="item.name" @click="links(item.url,item.jump_type)" :alt="item.name">
				</div>

			</el-carousel-item>
		</el-carousel>
		<!-- 轮播图 -->

		<!-- 中间内容 -->
		<router-view @getShopCode='getShopCode'/>
		
		
		
		<!-- 友情连接 -->
		<div class="friendly_links" v-if="friendly_links.length != 0">
			<p class="title">友情链接：</p>
			<template v-for="item in friendly_links">
				<el-link :href="item.url" target="_blank">{{item.name}}</el-link>
			</template>
		</div>
		
		
		<!-- 底部 -->
		<footer>
			<p>版权所有：中国智慧工程研究会职业教育专业委员会</p>
			<el-link href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802040976" target="_blank" style="color: #fff;"><img style="width: 16px;" src="../build/gwab.png" alt="">&nbsp;京公网安备 11010802040976号 &nbsp;&nbsp;</el-link>
			<el-link href="http://beian.miit.gov.cn" target="_blank" style="color: #fff;"> &nbsp;&nbsp;京ICP备2022033090号</el-link>
		</footer>
		
		<!-- 回到顶部 -->
		<el-backtop></el-backtop>
	</div>
</template>

<script>
	export default {
		name: 'App',
		data() {
			return {
				activeIndex2: '',
				search_value: '',//搜索框的值
				banners:[],//轮播图
				banners_interval:5000,//轮播图间隔
				friendly_links:[],//友情链接
				navs:[],//导航数据
				banner_show:'',//轮播图是否显示whole全局，nowhole非全局
				logoImg:'',//图片链接
			};
		},
		methods: {
			handleSelect(key, keyPath) {
				this.activeIndex2 = key
			},
			//请求轮播图
			query_banner(){
				var that = this
				this.$http.get('/banner').then(function(res) {
					// console.log(res)
					that.banner_show = res.data.banner_state
					that.banners = res.data.data
					that.banners_interval = res.data.interval
				})
			},
			//请求友情链接
			query_links(){
				var that = this
				this.$http.get('/friendly-link').then(function(res) {
					that.friendly_links = res.data.data
				})
			},
			//请求导航
			query_navs(){
				var that = this
				this.$http.get('/nav').then(function(res){
					// console.log(res)
					that.navs = res.data.data
				})
			},
			//友情链接点击跳转
			links(link,type){
				if(type == 'local'){
					this.$router.push(link);
				}else if(type == 'web'){
					window.open(link)
				}
			},
			
			//接受子组件传递过来的导航下标
			getShopCode(value){
				this.activeIndex2 = value
			},
			
			//跳转搜索结果
			search_result(){
				if(this.search_value == ''){
					this.$message.error('请输入要搜索的内容');
				}else{
					this.$router.push({path:'/search/result',query: {value:this.search_value}})
				}
			}
		},
		created() {
			document.title = '中国智慧工程研究会职业教育专业委员会'
		},
		mounted() {
			var that = this
			that.query_banner()
			that.query_links()
			this.query_navs()
			//请求logo
			this.$http.get('/logo').then(function(res){
				// console.log(res)
				that.logoImg = res.data.data
			})
		}
	}
</script>

<style>
	* {
		margin: 0;
		padding: 0;
		list-style-type: none;
	}
	header{
		width: 1190px;
		margin: 0 auto;
		display: flex;
		padding: 10px 20px;
		justify-content: space-between;
		align-items: center;
	}
	.logo{
		width: 90px;
		height: 90px;
		margin-right: 20px;
	}
	.header_l{
		display: flex;
		text-align: center;
		align-items: center;
	}
	.header_l .header_l_item .title{
		font-weight: bold;
		font-size: 32px;
		color: #303133;
	}
	.header_l .header_l_item .english{
		font-size: 14px;
		margin-top: 10px;
		color: #606266;
	}
	
	.banner_img{
		width: 100%;
		height: 100%;
		text-align: center;
	}
	.banner_img img{
		max-width: 100%;
		height: 100%;
		cursor: pointer;
		object-fit: cover;
	}
	
	/* 导航栏字体大小 */
	.el-menu-item,
	.el-submenu__title,
	.el-menu-item.is-active{
		font-size: 18px !important;
	}
	
	/* 导航栏字体大小 */
	
	.el-tabs__item{
		font-size: 18px;
		line-height: normal;
	}
	.el-tabs__item.is-active{
		font-size: 20px;
		color: #303133;
		font-weight: bold;
	}
	
	.el-tabs__active-bar{
		height: 4px;
	}
	.el-tabs__nav-wrap::after{
		height: 4px;
	}
	
	
	.el-menu-demo{
		display: flex;
		justify-content: center;
	}

	.el-carousel__item h3 {
		color: #475669;
		font-size: 18px;
		opacity: 0.75;
		line-height: 300px;
		margin: 0;
		text-align: center;
	}

	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n+1) {
		background-color: #d3dce6;
	}
	
	.friendly_links{
		width: 1270px;
		margin: 0px auto 5px;
		display: flex;
		flex-wrap: wrap;
	}
	.friendly_links .title{
		font-size: 18px;
		font-weight: bold;
	}
	.friendly_links .el-link{
		padding: 0 4px;
		margin: 0 14px;
		margin-bottom: 20px;
		font-size: 16px;
	}
	
	/* 菜单hover颜色 */
	.el-menu-item:hover {
	  background-color: #3a85ca !important;
	}
	.el-submenu .el-submenu__title:hover {
	  background-color: #3a85ca !important;
	}
	
	/* .el-table--enable-row-hover .el-table__body tr:hover>td{
	    background-color: #6495ED !important;
	}
	 */
	.el-input-group__append{
		background-color: rgb(0, 95, 175);
		color: #fff;
	}
	
	
	
	footer{
		min-height: 40px;
		background: rgb(0,95,175);
		text-align: center;
		font-size: 14px;
		color: #fff;
		padding: 20px 0 10px;
	}
	footer p{
		margin-bottom: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue